import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';

const styles = require('./index.less');

class InnerFloatRightStore extends BaseStore {
  @observable title = '';
  @observable type = 1; // 1: 预约阶段 2: 下载阶段
  @observable isOpen = true;
  @observable downloadUrl = {};
  supportUrl = 'https://support.seasungames.cn/product/jxsjsy4';
  // Avoid rendering the appointment skin before the async stage config resolves.
  @observable show = false;

  @observable
  download = {
    android: {
      url: 'android',
      name: '安卓下载'
    },
    ios: {
      url: 'apple',
      name: 'IOS下载'
    },
    pc: {
      url: 'pc',
      name: 'PC下载'
    }
  };

  changeOpen = isOpen => {
    this.isOpen = isOpen;
  };

  gotoIndex = index => {
    this.$history.replace(`/?currentPage=${index}`);
  };

  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  use() {
    super.use();
  }
}
export default InnerFloatRightStore;
